import React from "react";
import CrearTipoNovedad from "../components/Parametros/CrearTipoNovedad";

const AddNoveltyPage = () => {
  return <CrearTipoNovedad />;
};

export default AddNoveltyPage;
